import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    { path: '', data: { breadcrumb : '' }, loadChildren: () => import('./caixa-listar/caixa-listar.module').then(m => m.CaixaListarModule) }


  ])],
  exports: [RouterModule]
})
export class CaixaRoutingModule { }
